module.exports = __webpack_public_path__ + "/build/web/images/matching-pillows-option-standard.949b27584dcbc3826099a7d08812de20.png";


//////////////////
// WEBPACK FOOTER
// ./images/matching-pillows-option-standard.png
// module id = 171
// module chunks = 13